module.exports = __webpack_public_path__ + "img/1501230733.50febd47.jpg";